<template>
  <div class="cont-filter partner-integrations-filter bg-white pd-h-10 pd-t-20 pd-b-20">
    <span class="material-icons-outlined icon partner-integrations-filter__icon">
      settings_input_component
    </span>

    <div class="partner-integrations-filter__fields">
        <div class="input-comp input-comp-customer">
          <label for="customerFilter">CLIENTES</label>
          <div class="input-comp__control">
            <v-select
              v-model="filters.customer"
              placeholder="Selecione uma opção"
              label="name"
              :options="customers"
              name="customer"
              id="customerFilter"
              class="v-select-custom"
            >
              <template slot="option" slot-scope="option">
                <div v-if="option?.completeName" class="flex fd-c" style="border-bottom: 1px solid #e2e2e2;">
                  <strong>{{ option.completeName }} <small>({{ option.name }})</small></strong>
                  <span v-if="option?.federalID">CNPJ: {{ option.federalID }}</span>
                  <span v-if="option?.city || option?.federalUnity">{{ option?.city || 'N/A' }} / {{ option?.federalUnity || 'N/A' }}</span>
                </div>
              </template>
            </v-select>
          </div>
        </div>

        <div class="input-comp">
          <label for="teamFilter">EQUIPE / GRUPO</label>
          <div class="input-comp__control">
            <select v-model="filters.team" name="team" id="teamFilter">
              <option value="">Selecione um time</option>
              <option v-for="team in teams" :value="team.id" :key="team.id">
                {{ team.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="input-comp" v-if="!hideStep">
          <label for="stepFilter">ETAPA</label>
          <div class="input-comp__control">
            <select v-model="filters.step" name="step" id="stepFilter">
              <option value="">Selecione uma etapa</option>
              <option v-for="step in steps" :value="step.id" :key="step.id">
                {{ step.alias }}
              </option>
            </select>
          </div>
        </div>

        <div class="input-comp" v-if="showCustomsTeam">
          <label for="customsTeam">EQUIPE ADUANEIRA</label>
          <div class="input-comp__control">
            <select v-model="filters.customsTeam" name="customsTeam" id="customsTeam">
              <option value="">Selecione uma equipe</option>
              <option v-for="team in customsTeams" :value="team.id" :key="team.id">
                {{ team.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="input-comp input-comp-reference" v-if="showIdentification">
          <label for="identificationFilter">REF. DO PROCESSO</label>
          <div class="input-comp__control">
            <input
              type="text"
              v-model="filters.identification"
              id="identificationFilter"
              placeholder="Ex.: PRI00123"
            >
          </div>
        </div>

        <div class="input-comp input-comp-date" v-if="showDateRange">
          <label>DATA INICIAL</label>
          <div class="input-comp__control">
            <date-picker
              v-model="filters.startDate"
              lang="pt-br"
              format="DD/MM/YYYY"
              placeholder="Data inicial"
            />
          </div>
        </div>

        <div class="input-comp input-comp-date" v-if="showDateRange">
          <label>DATA FINAL</label>
          <div class="input-comp__control">
            <date-picker
              v-model="filters.endDate"
              lang="pt-br"
              format="DD/MM/YYYY"
              placeholder="Data final"
            />
          </div>
        </div>

      <div class="partner-integrations-filter__actions">
        <button
          type="button"
          class="crm-button text-center flex ai-c fgap1 partner-integrations-filter__button"
          @click.prevent="findProcessesWithData"
        >
          <span class="material-icons-outlined"> cached </span>
          <span>{{ labelButton }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import config from "@/config.js";
import DatePicker from "vue2-datepicker";

import {mapState} from "vuex";

export default {
  name: "PartnerIntegrationsFilter",
  data() {
    return {
      customers: [],
      teams: [],
      customsTeams: [],
      firstDate: null,
      secondDate: null,
      filters: {
        customer: null,
        team: null,
        step: null,
        customsTeam: null,
        startDate: null,
        endDate: null,
		identification: null
      },
    };
  },
  components: {
    DatePicker,
  },
  mounted() {
    this.getCustomers();
    this.getOperationalTeams();
    if (!this.hideStep) {
      this.$store.dispatch("ProcessStore/getSteps");
    }
    if (this.showCustomsTeam) {
      this.getCustomsTeams();
    }
  },
  props: {
	labelButton: {
		type: String,
		default: 'ATUALIZAR',
	},
	showIdentification: {
		type: Boolean,
		default: false,
	},
  hideStep: {
    type: Boolean,
    default: false,
  },
  showCustomsTeam: {
    type: Boolean,
    default: false,
  },
  showDateRange: {
    type: Boolean,
    default: false,
  },
  },
  computed: {
    ...mapState({
      steps: (state) => state.ProcessStore.steps,
    }),
  },
  methods: {
    findProcessesWithData() {
      const filters = {
        customerId: this.filters.customer ? this.filters.customer.id : null,
        teamId: this.filters.team ? this.filters.team : null,
        stepId: this.hideStep ? null : (this.filters.step ? this.filters.step : null),
        customsTeamId: this.filters.customsTeam ? this.filters.customsTeam : null,
        startDate: this.filters.startDate || null,
        endDate: this.filters.endDate || null,
		identification: this.filters.identification || null
      };

      this.$emit("find-processes-with-data", filters);
    },
    getCustomers() {
      Axios.get(
        `${config.env.API_DEFAULT.host}/companies/search/findAllByIsCustomerOrderByName?isCustomer=true`
      ).then((response) => {
        this.customers = response.data._embedded.companies;
      });
    },
    getOperationalTeams() {
      Axios.get(`${config.env.API_DEFAULT.host}/teams`).then((response) => {
        this.teams = response.data._embedded.teams;
      });
    },
    getCustomsTeams() {
      Axios.get(`${config.env.API_DEFAULT.host}/customs-teams`).then((response) => {
        this.customsTeams = response.data.data;
      });
    },
  },
};
</script>

<style scoped>
.cont-filter {
  gap: 20px;
}

.partner-integrations-filter {
  display: flex;
  align-items: flex-end;
  gap: 16px 20px;
}

.partner-integrations-filter__icon {
  flex-shrink: 0;
  align-self: center;
}

.partner-integrations-filter__fields {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px 20px;
  min-width: 0;
}

.partner-integrations-filter__actions {
  display: flex;
  align-items: flex-end;
  flex: 0 0 auto;
  margin-left: auto;
}

.partner-integrations-filter__button {
  display: flex !important;
  white-space: nowrap;
  min-height: 35px;
  height: 35px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-comp {
  min-width: 0;
}

.input-comp-customer {
  flex: 1 1 340px;
  min-width: 300px;
  max-width: 400px;
}

.input-comp:not(.input-comp-customer):not(.input-comp-reference):not(.input-comp-date) {
  flex: 1 1 170px;
  min-width: 150px;
  max-width: 210px;
}

.input-comp-reference {
  flex: 0 0 165px;
  width: 165px;
}

.input-comp-date {
  flex: 0 0 140px;
  width: 140px;
}

.input-comp label {
  display: block;
  margin-bottom: 4px;
  color: #868ba1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
}

.input-comp__control {
  border-bottom: 1px solid var(--gray-dark);
  min-height: 41px;
  display: flex;
  align-items: center;
  width: 100%;
}

.input-comp__control select,
.input-comp__control > input {
  border: 0;
  width: 100%;
  max-width: 100%;
  height: 35px;
  background: transparent;
  padding: 0;
  outline: none;
  box-shadow: none;
}

.input-comp__control select {
  cursor: pointer;
}

.input-comp-date .input-comp__control {
  padding-right: 0;
}

.input-comp-date .mx-datepicker {
  display: block;
  width: 100%;
  max-width: 100%;
}

.filter-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 10px 15px;
  font-size: 14px;
  border: 0;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease-in-out 0s;
  background-color: var(--blue);
  color: #ffffff;
}

.icon {
  color: var(--gray-dark);
}

@media (max-width: 1200px) {
  .partner-integrations-filter__icon {
    display: none;
  }
}

@media (max-width: 768px) {
  .partner-integrations-filter {
    flex-direction: column;
    align-items: stretch;
  }

  .partner-integrations-filter__fields {
    flex-direction: column;
    align-items: stretch;
  }

  .input-comp-customer,
  .input-comp:not(.input-comp-customer):not(.input-comp-reference):not(.input-comp-date),
  .input-comp-reference,
  .input-comp-date {
    flex: 1 1 auto;
    width: 100%;
    max-width: none;
    min-width: 0;
  }

  .partner-integrations-filter__actions {
    margin-left: 0;
    width: 100%;
  }

  .partner-integrations-filter__button {
    width: 100%;
    justify-content: center;
    height: auto;
    min-height: 40px;
  }
}
</style>

<style>

.partner-integrations-filter .input-comp__control .v-select,
.partner-integrations-filter .input-comp__control .v-select-custom {
  width: 100%;
}

.partner-integrations-filter .input-comp-customer .dropdown-menu {
  min-width: 100%;
  width: 100%;
}

body .partner-integrations-filter .input-comp__control .dropdown-toggle {
  display: flex;
  align-items: center;
  border: 0 !important;
  box-shadow: none !important;
  min-height: 35px !important;
  height: 35px !important;
  border-radius: 0 !important;
  padding: 0 !important;
  background: transparent !important;
}

body .partner-integrations-filter .input-comp__control .dropdown-toggle input {
  height: 35px !important;
  border: 0 !important;
  box-shadow: none !important;
  margin: 0;
  padding: 0;
  background: transparent !important;
}

body .partner-integrations-filter .input-comp__control .dropdown-toggle .selected-tag,
body .partner-integrations-filter .input-comp__control .dropdown-toggle .vs__selected-options {
  margin: 0;
  padding: 0;
}

.partner-integrations-filter .input-comp__control > input::placeholder,
.partner-integrations-filter .input-comp__control .dropdown-toggle input::placeholder {
  color: #868ba1;
}

.input-comp .v-select .open-indicator:before {
  border-color: black;
  border-width: 2px 2px 0 0;
  width: 7px;
  height: 7px;
}

.input-comp .mx-input-append::before {
  display: none;
}

.input-comp .mx-input-append {
  line-height: 0.5;
}

.input-comp .mx-input-wrapper .mx-clear-wrapper {
  margin-top: -3px !important;
  background-color: white !important;
  z-index: 9;
}

body .input-comp .mx-input-append svg {
  display: block !important;
}

.partner-integrations-filter .input-comp-date .mx-input-wrapper,
.partner-integrations-filter .input-comp-date .mx-input {
  width: 100% !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  height: 35px !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  background: transparent !important;
}

</style>

<style>
.v-select-custom .dropdown-toggle .clear {
  top: 9px !important;
}
</style>